/* eslint-disable react/prop-types */
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import { CreatePageStepsEnum } from '../types';
import useScreenSize from '../../../hooks/useScreenSize';
import { FilledCategory, SelectCategoryStepProps } from './types';
import { ItemCreationLayout } from '../ItemCreationLayout';
import { StepModalOptionText } from '../styled';
import { SelectCategoryOption, SelectCategoryOptionWrapper } from './styled';
import Icon from '../../Icon';
import {
  BUILDING_TYPE_ID,
  FORM_VALUES
} from '../../../utils/helpers/constants';
import { getCategoriesData } from '../../../utils/helpers';
import { getCategoryValues } from '../../../utils/helpers/common';
import { DealTypeTabs } from '../DealTypeTabs';
import { fillCategoriesWithData } from '../../../utils/helpers/fillCategoriesWithData';
import { generateDataStat } from '../../../utils/helpers/generateDataStat';

const tabsStats = [
  {
    value: 'false',
    dataStat: 'create_ad_step2_mode_sell'
  },
  {
    value: 'true',
    dataStat: 'create_ad_step2_mode_rent'
  }
];

export const SelectCategoryStep: React.FC<SelectCategoryStepProps> = ({
  setPageStep,
  categories
}) => {
  const {
    i18n: { language }
  } = useTranslation();
  const { isSmall } = useScreenSize();
  const { change } = useForm();

  const categoriesData = getCategoriesData({ data: categories, language });
  const filledCategories: FilledCategory[] = fillCategoriesWithData(
    categoriesData,
    true
  );

  const handleOptionClick = (category: FilledCategory) => {
    const newCategoryId =
      category.id === BUILDING_TYPE_ID.FLAT_ALL
        ? BUILDING_TYPE_ID.FLAT_NEW
        : category.id;
    change(FORM_VALUES.categoryId, newCategoryId);
    change(FORM_VALUES.typeEstate, category.name);
    const categoryValues = getCategoryValues({
      id: category.id,
      categories
    });
    change(FORM_VALUES.categoryValues, categoryValues);
    setPageStep(CreatePageStepsEnum.Form);
  };

  const iconSize = isSmall ? 43 : 53;

  return (
    <ItemCreationLayout
      cypress="category_modal"
      contentCypress="category-modal__content"
    >
      <DealTypeTabs dataStats={tabsStats} />

      <SelectCategoryOptionWrapper>
        {filledCategories.map((item, index) => (
          <SelectCategoryOption
            key={item.id}
            onClick={() => handleOptionClick(item)}
            data-cy="category_modal--option"
            data-stat={generateDataStat(item.newAdFormStat, isSmall)}
          >
            <Icon
              IconComponent={item.icon}
              width={iconSize}
              height={iconSize}
              indent={false}
              color={index !== 3 ? 'dark' : 'none'}
            />
            <StepModalOptionText tag="body_3">{item.name}</StepModalOptionText>
          </SelectCategoryOption>
        ))}
      </SelectCategoryOptionWrapper>
    </ItemCreationLayout>
  );
};
